import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { apiConfigResolver } from '@df/api/config/api-config.resolver';
import { basketItemsStockReloadResolver } from '@df/basket/stock-reload.resolver';
import { advancedCommerceRunResolvers } from '@df/module-advanced-commerce';
import { AdvancedCommerceConfigStore } from '@df/module-advanced-commerce/store/advanced-commerce-config.store';
import { CustomerReloadResolver } from '@df/session/customer/customer-reload.resolver';
import { DevOnlyGuard } from '@df/ui/dev-only.guard';
import { PlainRouterOutletComponent } from '@df/util/plain-router-outlet.component';
import { AppRootComponent } from './app-root.component';
import { BasketViewComponent } from './basket/basket-view.component';
import { Error500Component } from './catalog/ui/error-500.component';
import { LocalCustomerNotLoggedGuard } from './customer/guards/local-customer-not-logged.guard';
import { LoginViewComponent } from './login/view/login-view.component';
import { DynamicSearchComponent } from './search/dynamic-search.component';
import { dynamicSearchResolver } from './search/search.resolver';

export const appRoutes: Routes = [
    {
        path: '_library',
        canActivate: [DevOnlyGuard],
        resolve: {
            appData: apiConfigResolver
        },
        loadChildren: () =>
            import(
                /* webpackChunkName: "dfd.aw" */
                './module/df-demo/dfd.module'
            ).then(m => m.DfdModule)
    },
    {
        path: '',
        component: AppRootComponent,
        resolve: {
            appData: apiConfigResolver,
            acSwitch: () => inject(AdvancedCommerceConfigStore)?.loadConfig()
        },
        children: [
            {
                path: 'account',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "account.async" */
                        './account/account.routes'
                    ).then(m => m.accountRoutes)
            },
            {
                path: 'login',
                component: LoginViewComponent,
                canActivate: [LocalCustomerNotLoggedGuard],
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "login.async" */
                        './login/login.routes'
                    ).then(m => m.loginRoutes)
            },
            {
                path: 'basket',
                component: BasketViewComponent,
                resolve: {
                    customer: CustomerReloadResolver,
                    stock: basketItemsStockReloadResolver
                }
            },
            {
                path: 'checkout',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "checkout.async" */
                        './checkout/checkout.routes'
                    ).then(m => m.checkoutRoutes)
            },
            {
                path: 'search',
                component: PlainRouterOutletComponent,
                children: [
                    {
                        path: '**',
                        component: DynamicSearchComponent,
                        resolve: {
                            searchResult: dynamicSearchResolver
                        },
                        runGuardsAndResolvers: advancedCommerceRunResolvers
                    }
                ]
            },
            {
                path: 'error',
                component: Error500Component
            },
            {
                path: '**',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "catalog.async" */
                        './catalog/catalog.routes'
                    ).then(m => m.catalogRoutes)
            }
        ]
    }
];
